/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/ActionsAction/Content/Content/DeleteAction/Confirmation/Content/DeleteAction",
  onSubmit,
  isSubmitting
  
}) {
let deleteProceduresSubmitData = fromData.useDataSubmit({ viewPath,
context: 'delete_procedures',
})
let deleteProceduresIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'delete_procedures',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="delete_procedures"
 onClick={deleteProceduresSubmitData}
 disabled={deleteProceduresIsSubmittingData}
 text="Delete"
/>
{children}
</React.Fragment>)
}